export const BRAND_MANAGERS_META_DESCRIPTION_BG =
  "Perceptica помага на бранд мениджърите да анализират позиционирането на бранда, ефекта от кампаниите и действията на конкурентите чрез медиен мониторинг и медиен анализ.";
